import type { SceneNodeItem } from "../scene/SceneNodeItem";
import type { SceneTreeNode } from "../scene/SceneTreeItem";

/**
 * Type guard to check if a SceneNodeItem is of dataType "medium"
 */
export function isSceneMediumNode(node: SceneNodeItem): node is SceneNodeItem<"medium"> {
  return node.dataType === "medium";
}

export function isMediumTreeNode(treeNode: SceneTreeNode): treeNode is SceneTreeNode<"medium"> {
  return treeNode.node.dataType === "medium";
}
